export enum NUMBER_SELECTION_SUMMARY {
  BASE = 'base-game',
  MINI_GAME = 'mini-game',
}

export enum MatchStatus {
  MATCH = 'match',
  UNMATCHED = 'unmatched',
  UNKNOWN = 'unknown',
}
